<div
  fxLayout="column"
  fxLayoutAlign=" center"
  fxLayoutGap="8px"
  class="project-selector-component"
>
  <div class="inner-container" fxLayout="column" fxLayoutGap="12px">
    <!-- <div
      class="title-container"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div class="label">Projects</div>
      <div
        *ngIf="
          editable &&
          ['owner', 'admin', 'editor'].includes(myOrganisationRole$ | async)
        "
        class="add pointer"
        (click)="addProject()"
      >
        Add
      </div>
    </div> -->
    <ng-container *ngIf="(loading$ | async) === false; else loading">
      <div
        class="project-item blink"
        *ngIf="newProjectLoading$ | async"
        fxLayout="row"
      >
        New project is being created...
      </div>
      <div
        *ngFor="let project of projects$ | async"
        class="project-item flex-row"
        (mouseenter)="hoveredProject = project.id"
        (mouseleave)="hoveredProject = null"
        [routerLink]="
          isNameEditActive
            ? null
            : [
                '/',
                'organisations',
                project.organisationId || organisationId,
                'projects',
                project.id,
              ]
        "
      >
        <div>
          <nw-editable-text
            [text]="project.name"
            (textChanged)="nameChanged(project.id, $event)"
            (isActive)="isNameEditActive = $event"
            size="l"
            (click)="$event.stopPropagation()"
          ></nw-editable-text>
        </div>
        <div class="flex-row gap-6" *ngIf="isDeletePending != project.id">
          <nw-icon
            *ngIf="
              hoveredProject == project.id &&
              editable &&
              ['owner', 'admin'].includes(myOrganisationRole$ | async)
            "
            (click)="$event.stopPropagation(); deleteProject(project)"
            type="close"
            [size]="14"
            [outlined]="true"
          ></nw-icon>
        </div>
        <div *ngIf="isDeletePending == project.id">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      </div>
      <div *ngIf="(projects$ | async).length === 0">
        There are no projects yet..
      </div>

      <div
        *ngIf="
          editable &&
          ['owner', 'admin', 'editor'].includes(myOrganisationRole$ | async)
        "
        class="add pointer"
        (click)="$event.stopPropagation(); addProject()"
        matTooltip="Add new project"
      >
        +
      </div>
    </ng-container>
    <ng-template #loading>
      <div>Loading</div>
    </ng-template>
  </div>
  <div
    *ngIf="newProjectPanel"
    class="new-project-panel-container"
    (click)="$event.stopPropagation()"
  >
    <div class="new-project-panel">
      <div class="input-header">
        <div class="form-name">New Project</div>
        <nw-icon
          (click)="resetNewPanel()"
          type="close"
          [size]="10"
          [outlined]="true"
        ></nw-icon>
      </div>
      <div class="flex-row gap-6">
        <label for="new-organisation-name">Name</label>
        <input
          [(ngModel)]="newProjectName"
          (keydown)="$event.stopPropagation()"
          (keyup)="$event.stopPropagation()"
        />
      </div>
      <button [disabled]="!newProjectName" (click)="submitNewProject()">
        Add
      </button>
    </div>
  </div>
  <div *ngIf="editProjectPanel" class="edit-project-panel-container">
    <div class="edit-project-panel">
      <div class="input-header">
        <div class="form-name">{{ editProject.name }}</div>
        <nw-icon
          (click)="resetEditPanel()"
          type="close"
          [size]="10"
          [outlined]="true"
        ></nw-icon>
      </div>
      <div>
        <label for="edit-organisation-name">Name</label>
        <input [(ngModel)]="editProject.name" />
      </div>
      <div>
        <h3>Users</h3>
        <ng-container *ngFor="let user of organisationUsers$ | async">
          <div>
            <span
              >{{ user.firstName }} {{ user.lastName }} - {{ user.email }}</span
            >
            <select [ngModel]="user.role">
              <option value="viewer">Viewer</option>
              <option value="editor">Editor</option>
              <option value="admin">Admin</option>
              <option value="owner">Owner</option>
            </select>
            <button>Add</button>
          </div>
        </ng-container>
      </div>
      <button [disabled]="!editProject.name" (click)="submitEditedProject()">
        Save
      </button>
    </div>
  </div>
</div>
